module.exports = __webpack_public_path__ + "img/selection.2805d5ba.svg";